import React, { useState, useEffect } from "react";
import SearchIcon from "@material-ui/icons/Search";
import { useLocation } from "react-router-dom";
import { Paper, Grid } from '@material-ui/core';
import 'moment/locale/it.js';
import 'rc-datepicker/lib/style.css';
import { DatePickerInput } from 'rc-datepicker';
import Moment from "moment";
import BiztranControls from "../../biztran_controls/BiztranControls";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import UseFetchData from "../../../hooks/UseFetchData";

const todate = new Date()
//var fromdate = new Date();
//fromdate.setFullYear(fromdate.getFullYear() - 1, 0);
const fromdate = todate.getFullYear() - 1 + '/04/01';
//const fromdate = new Date().setFullYear(new Date().getFullYear()-1, 0);

const SalesTeamWise = () => {
  const [FromDate, setFromDate] = useState(fromdate);
  const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
  const [ToDate, setToDate] = useState(todate.toISOString());
  const [defaultToDate, setdefaultToDate] = useState(todate);
  const [Count, setCount] = useState('');
  const [ProductIDcmb, setProductIDcmb] = useState([]);
  const [AccountID, setAccountID] = useState('');
  const [AccountName, setAccountName] = useState('');
  const [AccName, setAccName] = useState('');
  const [responseAccount, fetchAccountData] = UseFetchData();
  const [AccountOptions, setAccountOptions] = useState([]);
  const [CountryCmb, setCountryCmb] = useState([]);
  const [SalesExecCmb, setSalesExecCmb] = useState([]);
  const [TimeScaleCmb, setTimeScaleCmb] = useState([]);
  const [SalesTeamData, setSalesTeamData] = useState([]);
  const [ProductID, setProductID] = useState('');
  const [TimeScaleID, setTimeScaleID] = useState('Monthly');
  const [CountryID, setCountryID] = useState('');
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [ComboDataResponse, fetchComboData] = UseFetchData();
  const [response, fetchData] = UseFetchData();

  const onFromClear = () => {
    setFromDate();
    setdefaultfromDate();
  }

  const onToClear = () => {
    setToDate();
    setdefaultToDate();
  }

  const PopulateData = () => {
    // debugger;
    var SalesTeamList = "";
    for (var i = 0; i < SalesTeamData.length; i++) {
      SalesTeamList += " '" + SalesTeamData[i]["id"] + "',"
    }
    var bodyFormData = new FormData();
    bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
    bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
    bodyFormData.append("ProductID", ProductID);
    bodyFormData.append("SalesExec", "");
    bodyFormData.append("AccountID", AccountID);
    bodyFormData.append("TimeScale", TimeScaleID);
    bodyFormData.append("CountryID", CountryID);
    bodyFormData.append("SalesTeamList", SalesTeamList);
    fetchData("SalesAnalysis/SalesTeamWiseList", bodyFormData);
  };

  const GetComboData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("ProductID", "");
    fetchComboData("SalesAnalysis/ComboData", bodyFormData);
  };

  const AccountData = () => {
    var bodyFormData = new FormData();
    fetchAccountData("SalesAnalysis/ComboData", bodyFormData);
  }


  useEffect(() => {
    if (ComboDataResponse !== undefined) {
      if (ComboDataResponse["Productcmb"] !== undefined && ComboDataResponse["CountryAuto"] !== undefined && ComboDataResponse["SalesExecutive"] !== undefined) {
        setProductIDcmb(ComboDataResponse["Productcmb"]);
        setCountryCmb(ComboDataResponse["CountryAuto"]);
        setSalesExecCmb(ComboDataResponse["SalesTeam"]);
      }
    }
  }, [ComboDataResponse]);

  useEffect(() => {
    // debugger;
    if (responseAccount['cmbAccount'] !== undefined && responseAccount['cmbAccount'].length > 0) {
      setAccountOptions(responseAccount['cmbAccount']);
    }
  }, [responseAccount['cmbAccount']]);

  const onACCChange = (event, newValue) => {
    setAccountName(newValue);
    setAccountID(newValue.id);
  }

  useEffect(() => {
    const gridCols = [
      /* {
        field: "id",
        headerName: ".",
        renderCell: (params) => (<strong> <a href="javascript:;" >Edit</a> </strong>),
        // renderCell: (params) => (<strong> <a href="javascript:;"  onClick={() => { openModal(params.getValue("id")); }} >Edit</a> </strong> ), 
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 70,
      }, */
      {
        field: "Sales Name",
        headerName: "Sales Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
    ];
    const copygridclm = gridCols.slice();
    //const data = Object.keys(response[0]);
    // debugger;
    var clm = {};
    if (response !== undefined && response.length > 0) {
      for (var i = 0; i < Object.keys(response[0]).length; i++) {
        if (Object.keys(response[0])[i] !== "id") {
          clm = {
            field: Object.keys(response[0])[i],
            headerName: Object.keys(response[0])[i],
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            width: 200,
          }
        }
        copygridclm.push(clm);
      }
    }
    setColumns(copygridclm);
    setRows(response);
    setCount(response.length);
  }, [response]);

  useEffect(() => {
    setTimeScaleCmb([
      { id: "Weekly", title: "Weekly" },
      { id: "Monthly", title: "Monthly" },
      { id: "Quarterly", title: "Quarterly" },
      { id: "Yearly", title: "Yearly" },
    ]);
    PopulateData();
    GetComboData();
    AccountData();
  }, [])

  function CustomToolbar() {
    return (
      <GridToolbarContainer style={{ marginLeft: '93%' }}>
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }

  return <Paper>
    <Grid container direction="row" >
      <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
        <div style={{ width: "200px", marginLeft: 6 }}>
          <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
          <DatePickerInput
            onChange={(jsDate, dateString) => setFromDate(dateString)}
            locale="en"
            displayFormat="DD/MMM/YYYY"
            className='my-react-component'
            onClear={() => { onFromClear(); }}
            showOnInputClick
            maxDate={new Date()}
            returnFormat="YYYY/MM/DD"
            defaultValue={defaultfromDate}
          />
        </div>
      </Grid>
      <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
        <div style={{ width: "200px", marginLeft: 16 }}>
          <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
          <DatePickerInput
            onChange={(jsDate, dateString) => setToDate(dateString)}
            locale="en"
            displayFormat="DD/MMM/YYYY"
            className='my-react-component'
            onClear={() => { onToClear(); }}
            showOnInputClick
            maxDate={new Date()}
            returnFormat="YYYY/MM/DD"
            defaultValue={defaultToDate}
          />
        </div>
      </Grid>
      <Grid xs={12} sm={3} md={3} lg={2} xl={2} style={{ marginTop: 12 }} >
        <BiztranControls.Select
          label="Time Scale"
          id="TimeScale"
          options={TimeScaleCmb}
          value={TimeScaleID}
          style={{ width: "227px" }}
          required
          onChange={(e) => setTimeScaleID(e.target.value)}
          SelectProps={{
            native: true,
          }}
        />
      </Grid>
    </Grid>
    <Grid container direction="row" style={{ marginTop: 5 }}>
      <BiztranControls.Select
        label="Product"
        id="Product"
        style={{ width: "227px" }}
        options={ProductIDcmb}
        onChange={(e) => setProductID(e.target.value)}
        SelectProps={{
          native: true,
        }}
      />
      <BiztranControls.Select
        label="Country"
        id="Country"
        style={{ width: "227px" }}
        options={CountryCmb}
        onChange={(e) => setCountryID(e.target.value)}
        SelectProps={{
          native: true,
        }}
      />
      <BiztranControls.Autocomplete
        label="Account Name"
        options={AccountOptions}
        style={{ marginLeft: 7, marginTop: -10, width: "285px" }}
        onChange={onACCChange}
        value={AccName}>

      </BiztranControls.Autocomplete>

    </Grid>
    <Grid container direction="row" >
      <BiztranControls.MultiselectAutocomplete
        label="Sales Team"
        options={SalesExecCmb}
        style={{ width: '79.5ch' }}
        onChange={(event, value) => setSalesTeamData(value)}
      />

      <label style={{ fontWeight: 'bold', width: 30, marginTop: 15, marginLeft: 7 }}>{Count}</label>
      <BiztranControls.Button
        responsive="true"
        text="SEARCH"
        startIcon={<SearchIcon />}
        onClick={() => {
          PopulateData();
        }}
      />
    </Grid>
    <BiztranControls.DataGrid
      rowHeight={25}
      headerHeight={34}
      rows={rows}
      columns={columns}
      checkboxSelection={false}
      //hideFooterPagination={true}
      //hideFooter={true}
      //Height="450px"
      autoHeight={true}
      Width="100%"
      components={{ Toolbar: CustomToolbar, }}
    />
  </Paper >;
};

export default SalesTeamWise;